<template>
    <v-carousel
            height="330px"
            progress
            :interval="8000"
            style="box-shadow: none !important; -webkit-box-shadow: none !important"
    >
        <v-carousel-item v-if="loading">
            <v-sheet
                    color="transparent"
                    height="100%"
                    tile
            >
                <v-layout wrap justify-center align-center fill-height>
                    <v-flex xs12 text-xs-center>
                        <v-progress-circular color="primary" width="2" indeterminate size="64"></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-sheet>

        </v-carousel-item>
        <v-carousel-item
                v-else
                v-for="(specialSale, i) in specialSales"
                :key=" i"
                :src="specialSale.image"
        >
            <v-sheet
                    class="special-sale-item-wrapper pa-4"
                    color="transparent"
                    height="100%"
                    tile
            >
                <div class="expires-at primary">Termina en {{expiresAt(specialSale.expires_at)}}</div>
                <div class="special-sale-overlay"></div>

                <v-layout wrap align-center justify-center fill-height pa-4>

                        <v-flex xs12 md4 lg3 xl2 pa-2 class="pig-wrapper">
                            <v-flex xs12 text-xs-center>
                                <v-icon size="54" color="accent">fas fa-piggy-bank</v-icon>
                            </v-flex>
                            <v-flex xs12 text-xs-center>
                                <h1 class="subtitle-1 black--text font-weight-bold">- {{specialSale.discount}}% </h1>
                                <v-divider dark class="mb-2"></v-divider>
                                <p class="title black--text mb-2">En {{specialSale.service_item.description}}</p>
                                <p class="caption black--text">({{specialSale.service_item.service.name}} )</p>
                            </v-flex>
                        </v-flex>

                        <v-flex xs12 md8 lg9 xl10 pl-2 >

                            <v-flex xs12  pa-2 class="hidden-sm-and-down title-wrapper">
                                <h2 class="display-1 black--text ">{{specialSale.title}}</h2>
                                <span
                                        class="d-inline-block text-truncate headline black--text "
                                        style="max-width: 300px"
                                >{{specialSale.description}}</span>
                            </v-flex>

                            <v-divider></v-divider>

                            <v-flex xs12 pa-2 hidden-sm-and-down class="provider-wrapper">
                                <v-avatar color="secondary" size="26">
                                    <v-img size="14" v-if="specialSale.service_provider.settings.avatar" :src="specialSale.service_provider.settings.avatar"></v-img>
                                    <v-icon v-else size="14">fas fa-building</v-icon>
                                </v-avatar>
                                <span class="black--text ml-2 subtitle-2">
                                    {{specialSale.service_provider.institution ? specialSale.service_provider.institution.name : `${specialSale.service_provider.user.first_name} ${specialSale.service_provider.user.last_name}`}}
                                </span>
                            </v-flex>

                            <v-flex xs12  pa-1 text-xs-center text-md-left>
                                <v-btn depressed @click="requestSpecialSale(specialSale.id)">Solicitar</v-btn>
                            </v-flex>

                        </v-flex>

                </v-layout>
            </v-sheet>
        </v-carousel-item>
        <quotation-request-form
                :show="showQuotationForm"
                v-on:change="onQuotationDialogChange"
                :special-sale-id="specialSaleId"
        >
        </quotation-request-form>
    </v-carousel>
</template>

<script>
    import QuotationRequestForm from '@/components/providers/QuotationRequestForm'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        components: {QuotationRequestForm},
        props: [],
        data(){
            return {
                loading: false,
                specialSaleId: null,
                showQuotationForm: false,
                specialSales: [],
                error: ''
            }
        },
        mounted(){
            this.getTopSales()
        },
        methods:{
            expiresAt(date){
                var vm = this
                return vm.$moment().to(vm.$moment(date, 'YYYY-MM-DD HH:mm:ss'), true)
            },
            requestSpecialSale(id){
                var vm = this
                vm.specialSaleId = id
                vm.$nextTick(function(){
                    vm.showQuotationForm=true
                })
            },
            onQuotationDialogChange(val){
                this.showQuotationForm = val
            },
            async getTopSales(){

                var vm = this
                vm.error = ''
                vm.loading = true
                const response = await ApiUtils.makeGet('public/special_sales/top')
                vm.loading = false

                if(!response.ok){
                    const json = await respnse.json()
                    vm.error = json.message || 'No hemos podido cargar las ofertas :('
                    return
                }

                const json = await response.json()
                vm.specialSales = json.result.special_sales

            }
        }
    }
</script>

<style scoped>

    .provider-wrapper{
        z-index:1;
        position:relative
    }

    .expires-at{
        position: absolute;
        top: 0;
        right: 0;
        width: 140px;
        font-size: 14px;
        font-weight: bold;
        border-radius: 0 0 0 10px;
        box-shadow: 2px 2px 20px #000;
        align-self: center;
        z-index: 1;
        text-align: center;
        padding: 5px;
    }

    .special-sale-overlay{
        position: absolute;
        top: 0;
        left: 0;
        height:100%;
        width:100%;
        z-index:0;

        background: rgb(255,255,255) !important;
        background: -moz-linear-gradient(90deg, rgba(255,255,255,0.8323704481792717) 0%, rgba(255,255,255,0.6951155462184874) 24%, rgba(255,255,255,0.5326505602240896) 38%, rgba(0,0,0,0) 58%, rgba(0,0,0,0) 100%)  !important;
        background: -webkit-linear-gradient(90deg, rgba(255,255,255,0.8323704481792717) 0%, rgba(255,255,255,0.6951155462184874) 24%, rgba(255,255,255,0.5326505602240896) 38%, rgba(0,0,0,0) 58%, rgba(0,0,0,0) 100%)  !important;
        background: linear-gradient(90deg, rgba(255,255,255,0.8323704481792717) 0%, rgba(255,255,255,0.6951155462184874) 24%, rgba(255,255,255,0.5326505602240896) 38%, rgba(0,0,0,0) 58%, rgba(0,0,0,0) 100%)  !important ;
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#000000",GradientType=1) !important;
    }

    .pig-wrapper{
        background-color: rgba(255,255,255,.5);
        border-radius: 10px;
        z-index:1
    }

    .title-wrapper{
        position: relative;
        z-index: 1
    }

    .special-sale-item-wrapper{
       background-color: rgba(0,0,0,.3) !important;
    }

    >>>.v-image__image.v-image__image--cover{
        filter: blur(5px)
       }

    >>>.v-carousel__controls{
        background-color: transparent;
    }
</style>